// src/components/AboutCoreSection.js
import React from "react";
import { Code2, Users, Rocket, CheckCircle } from "lucide-react";
import TeamworkIllustration from "../assets/teamwork.svg"; // Make sure this image exists in your assets

const coreValues = [
  {
    title: "Technical Excellence",
    description:
      "We engineer robust, scalable systems using modern technologies, clean architecture, and proven practices.",
    icon: <Code2 className="w-6 h-6 text-white" />,
    bg: "bg-[#4C47DC]",
  },
  {
    title: "Client-First Culture",
    description:
      "We collaborate closely with clients to understand their goals and deliver outcomes that make real business impact.",
    icon: <Users className="w-6 h-6 text-white" />,
    bg: "bg-[#4C47DC]",
  },
  {
    title: "Agile Mindset",
    description:
      "We move with speed and purpose, embracing flexibility, continuous learning, and a focus on delivering value.",
    icon: <Rocket className="w-6 h-6 text-white" />,
    bg: "bg-[#4C47DC]",
  },
];

const reasons = [
  "We combine engineering precision with creative problem-solving.",
  "We build scalable, modern software that grows with your business.",
  "We believe in honest communication and long-term partnerships.",
];

const AboutCoreSection = () => {
  return (
    <section className="bg-white py-20" id="about-core">
      <div className="max-w-7xl mx-auto px-6">
        {/* Heading and Intro */}
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-2">
            About Badami Labs
          </h2>
          <p className="text-gray-600 max-w-3xl mx-auto">
            We are a Bangalore-based software company helping startups and enterprises build modern, reliable, and impactful digital products. From strategy to execution, we act as a true technology partner focused on long-term success.
          </p>
        </div>

        {/* Core Values */}
        <div className="grid md:grid-cols-3 gap-6 mb-16">
          {coreValues.map((item, index) => (
            <div
              key={index}
              className="bg-gray-50 hover:shadow-lg transition-all duration-200 rounded-lg p-6 text-left group"
            >
              <div
                className={`w-10 h-10 flex items-center justify-center rounded-full mb-4 ${item.bg}`}
              >
                {item.icon}
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                {item.title}
              </h3>
              <p className="text-sm text-gray-600">{item.description}</p>
            </div>
          ))}
        </div>

        {/* Why Work With Us Section */}
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <img
              src={TeamworkIllustration}
              alt="Teamwork Illustration"
              className="w-full h-auto"
            />
          </div>
          <div>
            <h3 className="text-2xl font-semibold text-gray-900 mb-6">
              Why Work With Us
            </h3>
            <ul className="space-y-4 text-gray-700 text-sm">
              {reasons.map((reason, index) => (
                <li key={index} className="flex items-start space-x-3">
                  <CheckCircle className="w-5 h-5 text-[#4C47DC] mt-1 flex-shrink-0" />
                  <span>{reason}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutCoreSection;
